import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return localStorage.getItem("cvg_user") || sessionStorage.getItem("cvg_user") || null;
    } catch (error) {
      console.log("error while parsing data");
      return null;
    }
  });

  const login = (user, rememberMe = false) => {
    if (rememberMe) {
      localStorage.setItem("cvg_user", user);
    } else {
      sessionStorage.setItem("cvg_user", user);
    }
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("cvg_user");
    sessionStorage.removeItem("cvg_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
